import * as React from 'react'
import { DueDateDropdownConnected } from './DueDateDropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const DueDateDropdownExamples = () => {
  return (
    <div className="DueDateDropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <DueDateDropdownConnected taskId="123" />
      </Provider>
    </div>
  )
}
